import { Component, HostBinding, TemplateRef } from '@angular/core';
import { ToastMessageService } from '../../services/toast-message.service';

@Component({
    selector: 'app-toasts',
    template: `
        <ngb-toast
            *ngFor="let toast of getToasts()"
            [class]="toast.classname"
            [autohide]="toast.autohide ?? true"
            [delay]="toast.delay"
            (hidden)="removeToast(toast)"
        >
            <div class="toast-content">
                <div class="toast-message">
                    <ng-template [ngIf]="isTemplate(toast)" [ngIfElse]="text">
                        <ng-template
                            [ngTemplateOutlet]="toast.textOrTpl"
                        ></ng-template>
                    </ng-template>
                    <ng-template #text
                        ><span [innerHTML]="toast.textOrTpl"></span
                    ></ng-template>
                </div>
                <button
                    *ngIf="toast.autohide === false"
                    class="toast-close-btn"
                    (click)="removeToast(toast)"
                    aria-label="Close"
                >
                    &times;
                </button>
            </div>
        </ngb-toast>
    `,
    styleUrls: ['./toast-message-container.component.scss'],
    standalone: false,
})
export class ToastMessageContainerComponent {
    @HostBinding('class') class =
        'toast-container position-fixed top-2 end-0 p-3';

    @HostBinding('style.z-index') styleZIndex = '1200';

    constructor(private toastMessageService: ToastMessageService) {}

    isTemplate(toast) {
        return toast.textOrTpl instanceof TemplateRef;
    }

    removeToast(toast) {
        this.toastMessageService.remove(toast);
    }

    getToasts() {
        return this.toastMessageService.toasts;
    }
}
